import React from "react";
import { Card, Radio } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";

const ReviewScore = ({ category, borderClass, items,  value, scaleMap, onChange, hoverBorderClass, ringClass, categoryId, mode }) => {

  const handleChange = (e) => onChange(e.target.value);
  const selectedItem = items.find((item) => item.rate === value);

  const getStatusClass = (scale) =>
    (scaleMap[scale] || "")
      .toLowerCase()
      .replace(/\s+/g, "-");

  return (
    <Card className={`my-6 rounded-xl dark:bg-intsamis-900 ${borderClass}`}>
      <div className="flex justify-between mb-3">
        <h5 className="font-semibold text-[15px] dark:text-white">{category}</h5>
        {selectedItem && (
          <span className={`text-xs font-medium status-indicator ${getStatusClass(selectedItem.scale)}`}>
            {selectedItem.scale}
          </span>
        )}
      </div>
      <FormItem
          name={["overall_rating", categoryId]}
          rules={[requiredField]}
      >
        <Radio.Group 
          value={value} 
          onChange={handleChange} 
          className="w-full dark:bg-instamis-800 dark:hover:border-emerald-100 "
        >
          <div className="flex flex-col gap-3">
            {items.map((item) => (
              <label
                key={item.rate}
                className={`
                  flex items-start justify-between p-4 rounded-lg
                  border dark:border-gray-500
                  ${mode === "view" ? "" : hoverBorderClass}
                  ${value === item.rate ? `ring-2 ${ringClass}` : ""}
                `}
              >
                <div className="flex items-start gap-3">
                  <Radio value={item.rate} className="green-radio" disabled={mode === "view"}/>
                  <div>
                      <div className="flex items-baseline gap-2 mb-1 title-text">
                        <span className="font-semibold text-[14px]">{item.rate}</span>
                        <span className="text-[14px] font-medium">{item.scale}</span>
                        {item.description && (
                          <p className="text-[13px] muted-text">{item.description}</p>
                        )}
                      </div>
                  </div>
                </div>
                <span className={`text-xs font-medium status-indicator ${getStatusClass(item.scale)}`}>
                  {item.points} pts
                </span>
              </label>
            ))}
          </div>
        </Radio.Group>
      </FormItem>
    </Card>
  );
};

export default ReviewScore;
